import { create } from 'zustand';

type TripSelectionState = {
  lastViewedTripId?: string;
  rememberTripId: (tripId?: string | null) => void;
};

export const useTripSelectionStore = create<TripSelectionState>((set) => ({
  lastViewedTripId: undefined,
  rememberTripId: (tripId) => {
    if (!tripId) {
      return;
    }

    set((state) => {
      if (state.lastViewedTripId === tripId) {
        return state;
      }

      return { lastViewedTripId: tripId };
    });
  },
}));
